import React from 'react'
import { makeNav } from './styled'
import FlexContainer from '../../shared/flex-container'
import CareguideLogo from 'components/corpSite/imgs/careguide-corp/icons/cg-grey.svg'
import MobileNav from './mobile-nav/index.js'
import Hamburger from './hamburger/index.js'

export const RawNav = makeNav('nav')

class Nav extends React.Component {
  state = { menuOpen: false }

  handleHamburgerClick = () => {
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  render() {
    return (
      <RawNav {...this.props}>
        <FlexContainer direction='row' justifyContent='space-between' className='main-nav'>
          <div className='logo'>
            <a href='/'>
              <img src={CareguideLogo} />
            </a>
          </div>
          <FlexContainer direction='row' justifyContent='space-around' className='nav-links'>
            <div className={`nav-section ${this.props.selected == 'caregiver' ? 'selected' : ''}`}>
              <a href='/care-services'>
                <span className='link'>Care Services</span>
              </a>
              <div className='dropdown-bounding-box'>
                <div className='nav-dropdown'>
                  <a href='/child-care'>Child Care</a>
                  <a href='/home-care'>Home Care</a>
                  <a href='/pet-care'>Pet Care</a>
                  <a href='/elder-care'>Elder Care</a>
                </div>
              </div>
            </div>
            <a href='/payroll-services'>
              <div className={`nav-section ${this.props.selected == 'payroll' ? 'selected' : ''}`}>
                <span className='link'>Payroll Services</span>
              </div>
            </a>
            <div className={`nav-section ${this.props.selected == 'company' ? 'selected' : ''}`}>
              <a href='/about'>
                <span className='link'>Company</span>
              </a>
              <div className='dropdown-bounding-box'>
                <div className='nav-dropdown'>
                  <a href='/team'>Team</a>
                  <a href='/careers'>Work With Us</a>
                  <a href='/news-ideas'>News & Ideas</a>
                  <a href='/branding'>Brand Assets</a>
                </div>
              </div>
            </div>
            <a href='/contact'>
              <div
                className={`nav-section last ${this.props.selected == 'contact' ? 'selected' : ''}`}
              >
                <span className='link'>Contact</span>
              </div>
            </a>
          </FlexContainer>
          <Hamburger onClick={() => this.handleHamburgerClick()} open={this.state.menuOpen} />
        </FlexContainer>
        <MobileNav className='mobile-nav' open={this.state.menuOpen} />
      </RawNav>
    )
  }
}

export default Nav
